module.exports = __webpack_public_path__ + "static/media/bg19.3b16b7a4.jpg";